import React from 'react'
import { Form } from 'react-bootstrap'
import ReactQuill from 'react-quill'
import { CHAR_LIMITS, QUILL_FORMATS, TABS } from './constants'

const WebsiteAnnouncementMessage = ({
  publicState,
  publicQuillRef,
  publicQuillModules,
  handlePublicMessageChange,
  getPlainTextLength,
  pasteError,
}) => {
  return (
    <div className='announcement-editor-section'>
      <Form.Label className='mb-1 fw-semibold'>Message</Form.Label>
      <ReactQuill
        ref={publicQuillRef}
        theme='snow'
        value={publicState.message}
        onChange={handlePublicMessageChange}
        modules={publicQuillModules}
        formats={QUILL_FORMATS}
        placeholder='Type your website announcement message here...'
      />
      <div className='announcement-char-counter'>
        <span className={getPlainTextLength(publicState.message) === CHAR_LIMITS[TABS.PUBLIC] ? 'text-danger fw-semibold' : 'text-muted'}>
          {getPlainTextLength(publicState.message)} / {CHAR_LIMITS[TABS.PUBLIC]} characters used
        </span>
        {getPlainTextLength(publicState.message) === CHAR_LIMITS[TABS.PUBLIC] ? (
          <span className='announcement-char-warning text-danger'>
            Maximum character limit reached. No more text can be added.
          </span>
        ) : pasteError && (
          <span className='announcement-char-warning text-danger'>
            {pasteError}
          </span>
        )}
      </div>
    </div>
  )
}

export default WebsiteAnnouncementMessage
